// PDFViewer.js
import React from 'react';
import MegazinePdfTwo from "../pdf/SPECIALIST_ACC_2014_1.pdf";

const PdfViewerTwo = () => {

  return (
    <div className="pdf-viewer mobile" >

          <div className="pdf-viewer">
            <object data={MegazinePdfTwo} type="application/pdf" width="100%" height="800">
              <embed src={MegazinePdfTwo} type="application/pdf" width="100%" height="800" />
            </object>
          </div>

    </div>
  );
};

export default PdfViewerTwo;
